document.addEventListener("DOMContentLoaded", () => {
    const container = document.querySelector(".history-list");
    
    if (container) { 
        const items = Array.from(container.querySelectorAll(".item"));
        console.log(items);
        // Sort elements by numeric ID
        items.sort((a, b) => Number(a.id) - Number(b.id));
        console.log('sorted', items);
        // Append sorted elements back to the container
        items.forEach(item => container.appendChild(item));
    }
});